/**
 * Tiny logging wrapper. Centralizes console usage so it can be silenced or
 * routed to a real logging service in production without touching call sites.
 */
const isProd = process.env.NODE_ENV === "production";

export const logger = {
  error: (...args) => {
    if (!isProd) console.error(...args);
    // In production, forward to an error-reporting service here if configured.
  },
  warn: (...args) => {
    if (!isProd) console.warn(...args);
  },
  debug: (...args) => {
    if (!isProd) console.debug(...args);
  },
};
